<template>
    <el-dialog
        title="3D场景"
        :visible.sync="dialogVisible"
        width="800" v-loading="loading">
        <div>
            <model-obj
                :backgroundAlpha="0"
                @on-load="onLoad"
                src="../../assets/模型库/7B0DIOC5I3VG4HEUZRN6BXVEV.obj"></model-obj>
        </div>
    </el-dialog>
</template>

<script>
    import { ModelObj } from 'vue-3d-model'
    export default {
        name: "modelView",
        data(){
            return{
                dialogVisible: false,
                loading: true
            }
        },
        components: {
            ModelObj
        },
        methods: {
            init(){
                this.dialogVisible = true
            },
            onLoad() {
                this.loading = false;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/model/modelView.vue